export function useTicket() {
    const createTicketCounter = () => {
        let nextTicket = Number.MIN_SAFE_INTEGER;

        return () => {
            const result = nextTicket;
            if (nextTicket === Number.MAX_SAFE_INTEGER) {
                nextTicket = Number.MIN_SAFE_INTEGER;
            } else {
                nextTicket += 1;
            }

            return result;
        }
    }
    

    return {
        createTicketCounter,
    }
}